export default async function (name, e, type = 'error', attr = {}, index = 1) {
    const { user, organization } = this.$store.getters;
    const message = {
        name: name,
        error: {
            message: e instanceof Error ? e.message : null,
            stack: e instanceof Error ? e.stack : null,
        },
        info: {
            userId: user.id,
            organizationId: organization.id,
            time: window.moment().format(),
            timeZoneClient: window.moment.tz.guess(),
            timeZoneOrganization: user.timezone,
            ...attr,
        },
    };

    if (window.newrelic) {
        setTimeout(() => {
            window.newrelic.noticeError(new Error(JSON.stringify(message)), {
                name: name,
                type: type,
                userId: user.id,
                organizationId: organization.id,
                ...attr,
            });
        }, 1000 * index);
    }
}
